import { useState } from "react";
import { catGroups } from "@/mocks/trending";

const dotMap: Record<string, string> = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-500 text-foreground-950",
  secondary: "bg-secondary-500 text-background-50",
};
const chipMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800",
  accent: "bg-accent-100 text-accent-900",
  secondary: "bg-secondary-100 text-secondary-900",
};

export default function CatSections() {
  const [activeKey, setActiveKey] = useState(catGroups[0].key);
  const active = catGroups.find((g) => g.key === activeKey) ?? catGroups[0];
  const [bookmarked, setBookmarked] = useState<Record<number, boolean>>({});

  const toggleBook = (id: number) => setBookmarked((p) => ({ ...p, [id]: !p[id] }));

  return (
    <section id="feed" className="w-full bg-background-100 px-4 py-12 md:px-8 md:py-16 lg:px-14">
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 text-center">
          <p className="mb-2 inline-flex items-center gap-2 rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-foreground-600">
            <i className="ri-layout-grid-fill text-primary-500" aria-hidden="true"></i> 四大栏目 · 持续追踪
          </p>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            按你的口味，<span className="text-primary-500">挑着吃瓜</span>
          </h2>
        </div>

        <div className="mx-auto mb-8 flex max-w-3xl flex-wrap items-center justify-center gap-2 rounded-full border border-background-200 bg-background-50 p-1">
          {catGroups.map((g) => (
            <button
              key={g.key}
              onClick={() => setActiveKey(g.key)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors md:px-6 ${
                g.key === activeKey ? "bg-primary-500 text-background-50" : "text-foreground-600 hover:text-primary-700"
              }`}
            >
              {g.name}
            </button>
          ))}
        </div>

        <div className="mb-6 flex items-center justify-between gap-4">
          <div>
            <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950 md:text-xl">
              <span className={`flex h-7 w-7 items-center justify-center rounded-lg ${dotMap[active.accent]}`}>
                <i className="ri-chat-smile-3-line text-sm" aria-hidden="true"></i>
              </span>
              {active.name}
            </h3>
            <p className="mt-1 text-sm text-foreground-500">{active.desc}</p>
          </div>
          <span className="hidden shrink-0 text-xs text-foreground-400 sm:block">{active.items.length} 篇 · 已跟进</span>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {active.items.map((it, idx) => (
            <article key={it.id} className="group flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200 hover:bg-background-50">
              <div className="flex items-center justify-between gap-2">
                <span className={`rounded-full px-2.5 py-1 text-xs font-medium ${chipMap[active.accent]}`}>{it.tag}</span>
                <span className="text-xs text-foreground-400">#{String(idx + 1).padStart(2, "0")}</span>
              </div>
              <h4 className="mt-3 text-base font-semibold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-[17px]">
                {it.title}
              </h4>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{it.summary}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3">
                <span className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line" aria-hidden="true"></i> {it.heat}
                </span>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => toggleBook(it.id)}
                    aria-pressed={!!bookmarked[it.id]}
                    aria-label="收藏"
                    className={`flex h-8 w-8 items-center justify-center rounded-full transition-colors ${
                      bookmarked[it.id] ? "bg-accent-100 text-accent-800" : "text-foreground-400 hover:bg-background-100 hover:text-accent-700"
                    }`}
                  >
                    <i className={`${bookmarked[it.id] ? "ri-bookmark-fill" : "ri-bookmark-line"} text-base`} aria-hidden="true"></i>
                  </button>
                  <a
                    href="#features"
                    className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800"
                  >
                    读全文 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}